import React, { useState } from "react";
import AddOrEditLopSettings from "./AddOrEditLopSettings";
import SlidingPane from "react-sliding-pane";
import { useViewLopSettings } from "../../queries/payrollQuries";
import LOPCard from "./LOPCard"
const LOPSettingsComponents = () => {
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const {
    data: lopSettingsData,
    isLoading,
    error,
  } = useViewLopSettings();

  const LOPData = lopSettingsData?.data || [];

  const handleClosePane = () => {
    setIsPaneOpen(false);
    setEditData(null);
  };

  if (isLoading) {
    return (
      <div className="px-10 py-6 w-full">
        <p>Loading LOP Data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="px-10 py-6 w-full">
        <p className="text-red-500">Failed to load LOP Settings.</p>
      </div>
    );
  }

  return (
    <div className="px-10 py-6 w-full">
      <div className="px-10 flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">LOP Settings</h2>
  
  <button
    type="button"
    className="btn text-sm font-medium"
    onClick={() => {
      setEditData(null);
      setIsPaneOpen(true);
    }}
  >
    Add LOP Settings
  </button>


      </div>

      <div className="w-full flex flex-wrap gap-6 mx-10">
      <LOPCard data={LOPData} onEdit={(item) => {
  setEditData(item);
  setIsPaneOpen(true);
}} />
      </div>

      {isPaneOpen && (
        <SlidingPane
          isOpen={isPaneOpen}
          title={editData ? "Edit Lop Settings" : "Add Lop Settings"}
          from="right"
          width="450px"
          onRequestClose={handleClosePane}
        >
          <AddOrEditLopSettings
            closePane={handleClosePane}
            editData={editData}
            isEditMode={!!editData}
          />
        </SlidingPane>
      )}
    </div>
  );
};

export default LOPSettingsComponents;
